import { escapeHtml } from "../utils/escape-html";
function isIterable(value) {
    return typeof value === "object" && value !== null && Symbol.iterator in value;
}
export function raw(markup) {
    return {
        __lpTemplateResult: true,
        toString: () => markup,
        [Symbol.toPrimitive]: () => markup,
    };
}
function isTemplateResult(value) {
    return typeof value === "object" && value !== null && "__lpTemplateResult" in value;
}
function stringifyRenderable(value) {
    if (value === null || value === undefined || value === false) {
        return "";
    }
    if (typeof value === "string" || typeof value === "number" || value === true) {
        return escapeHtml(String(value));
    }
    if (isTemplateResult(value)) {
        return String(value);
    }
    if (isIterable(value)) {
        return Array.from(value, stringifyRenderable).join("");
    }
    return String(value);
}
export function html(strings, ...values) {
    const markup = strings.reduce((output, string, index) => {
        const value = values[index];
        return output + string + stringifyRenderable(value);
    }, "");
    return raw(markup);
}
